import { TrayServiceType } from './rofl';
import { ActionPropertyValuesResult, Lookup, PropertyType } from './roflWorkflowActionProperty';

/**
 *  RecordOperationType determines how the fields of record properties will be handled in the UI.
 */
export enum RecordOperationType {
    CREATE = 'create',
    UPDATE = 'update',
    UPSERT = 'upsert',
}

/**
*   InputProperty represents a property the user must provide when setting up the workflow action.
*/
export interface InputProperty {
    // Name will be used to specify the value of this property in the models.ActionConfig specified in a workflow node.
    name: string;
    // DisplayName is the UI display name for this property.
    display_name?: string;
    // Type determines the internal type of the property.
    // Types should in general follow our internal CDP types, but some use cases will require more complex ones.
    type: PropertyType;
    // Lookup is used to tell the UI that the property supports looking up values through subsequent requests.
    lookup?: Lookup;

    enum?: ActionPropertyValuesResult[];

    // depends_on specifies the list of properties whose values determine what values are valid for this property.
    depends_on?: string[];
    // required determines whether the property must have a value for the workflow action to work.
    required: boolean;

    // record_operation is used to determine how the fields of record properties will be handled in the UI.
    record_operation?: RecordOperationType;
}

/**
*   WorkflowAction is the core building block for the workflows service. This represents an action that can be run
*   as a workflow node and contains information about the type of entity the action can run for, among other things.
*/
export interface WorkflowAction {
    // Eid is used as the external identifier for the workflow action, mostly used as url segments.
    eid: string;
    // DisplayName is the UI display name for the action
    display_name: string;
    // Properties determines the user input properties of this action.
    properties: InputProperty[];
    depends_on?: string[];
}

/**
 * WorkflowActionService represents a single workflow action service and its associated actions
*/
export interface WorkflowActionService {
    service_name: TrayServiceType;
    service_display_name: string;
    workflow_actions: WorkflowAction[];
}

/**
 * Account-based action panel > contact filters
 */
export interface IWorkflowAccountActionContactFilter {
    rule_type: string;
    source: string;
    object: string;
    attribute_rule_index: number;
    attribute_name: string;
    display_name: string;
    type: string;
    operator: 'in' | 'contains' | 'exists' | 'not_in' | 'not_contains' | 'not-exists';
    value?: string; // for single-value rules
    values?: string[]; // for multi-value rules
}
